module.exports = __webpack_public_path__ + "static/media/Checkmark-circle.1a0fcc3a.svg";